import { httpCreate } from './http';

const http = httpCreate('/srv/activity-comment-effects');

export const activityCommentEffects = {
	change(activityId, data) {
		return http.post(`/${activityId}`, data);
	},
	getEffectsData(activityId) {
		return http.get(`/${activityId}`);
	},
};
